import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { id: 'Artboard-32' }),
  React.createElement('path', { d: 'M16 3.72A12.28 12.28 0 1 0 28.28 16 12.3 12.3 0 0 0 16 3.72zM16 27a11 11 0 1 1 11-11 11 11 0 0 1-11 11z' }),
  React.createElement('path', { d: 'M19.89 11.19L16 15.08l-3.89-3.89-.92.92L15.08 16l-3.89 3.89.92.92L16 16.92l3.89 3.89.92-.92L16.92 16l3.89-3.89-.92-.92z' })
));